import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-dropdown', 'openLang', 'Ava keele valik');
Labels.set('ui-dropdown', 'countryCode', 'Riigi suunakood');
Labels.set('ui-dropdown', 'listboxName', 'Võimalikud valikud');

Labels.set('ui-dropdown', 'eng', 'Inglise');
Labels.set('ui-dropdown', 'est', 'Eesti');
Labels.set('ui-dropdown', 'rus', 'Vene');
